export default "__VITE_ASSET__40e05479__"